module.exports = __webpack_public_path__ + "img/derechoambiental.ba8c632d.png";